import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ClassModel, ClassService } from '../class';
import { instanceToInstance } from 'class-transformer';

@Component({
  selector: 'app-class-dialog',
  templateUrl: './class-dialog.component.html',
  styleUrls: ['./class-dialog.component.scss']
})
export class ClassDialogComponent implements OnInit {

  public isEditDialog = false;
  public inProgress: boolean = false;
  public unchangedData: ClassModel;

  constructor(
    public dialogRef: MatDialogRef<ClassDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ClassModel,
    private classService: ClassService) {
    if (data._id) {
      this.isEditDialog = true;
      this.unchangedData = instanceToInstance(data);
    }
  }

  ngOnInit(): void {
  }

  abort(): void {
    this.dialogRef.close();
  }

  save(): void {
    if (this.isEditDialog && this.hasDataChanged()) {
      this.inProgress = true;
      this.classService.update(this.data).subscribe(
        (res) => { },
        (err) => { },
        () => {
          this.inProgress = false;
          this.dialogRef.close(this.data);
        }
      )
    } else {
      this.dialogRef.close(this.data);
    }
  }

  hasDataChanged(): boolean {
    return (JSON.stringify(this.unchangedData) !== JSON.stringify(this.data));
  }



}
